const LOCAL_STORAGE_KEY = {
    REFRESH_TOKEN: 'autentika_app_refresh_token',
    TOKEN: 'autentika_app_token',
    ADMIN_ROLE: 'admin_role_access',
    WEB_HOST: 'autentika_web_host'
}


export default LOCAL_STORAGE_KEY;